import { ErrorItem } from '../components/ErrorsPresenter/ErrorsPresenter';

export interface AppTracker {
    trackerId?: string;
    trackingSystem?: string;
    url?: string;
    baseUrl?: string;
    baseUrlWithId?: string;
    urlEditable?: boolean;
    userParams?: Array<string>;
    selectedParams?: AppTrackerParams;
    selectedUserParams?: AppTrackerParams;
}

export interface TrackingParametersEditorState {
    tracker: AppTracker;
    errors?: ErrorItem[];
    osType?: string;
}

export type AppTrackerParams = Array<{
    name: string;
    value: string;
}>;

export type JavaAppTrackersTemplates = Array<JavaAppTrackerTemplate>;

export interface JavaAppTrackerTemplate {
    baseUrlTemplate: string;
    editable: boolean;
    parameters: Array<JavaAppTrackerTemplateParameter>;
    trackingSystem: string;
    trackingSystemName: string;
    urlTemplateAndroid: string;
    urlTemplateIos: string;
}

export interface JavaAppTrackerTemplateParameter {
    description: string;
    name: string;
    osType: string;
    required: boolean;
    value: string;
}

export const MOBILE_APP_ID = 'MOBILE_APP_ID';

export type TrackingParametersId = typeof MOBILE_APP_ID;

export type TrackingParametersEditorsState = {
    data: Record<TrackingParametersId, TrackingParametersEditorState>;
    trackersTemplates: JavaAppTrackersTemplates;
};
